export * from './usePrepareTabData';
export * from './useTeacherDetailPage';
